export enum Type {
  VIDEOS_GET_REQUEST = 'app/video-search/VIDEOS_GET_REQUEST',
  VIDEOS_GET_SUCCESS = 'app/video-search/VIDEOS_GET_SUCCESS',
  VIDEOS_GET_FAILURE = 'app/video-search/VIDEOS_GET_FAILURE',

  VIDEO_SEARCH_RESULTS_CLEAR = 'app/video-search/VIDEO_SEARCH_RESULTS_CLEAR',
  VIDEO_SEARCH_RESULTS_CLEAR_ALL = 'app/video-search/VIDEO_SEARCH_RESULTS_CLEAR_ALL',
}
